import { Messages } from '~src/codegen/Localize';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { getAppStore } from '../../../bootstrap/redux/store/AppStore';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { editWorkbookDraft } from '../../../workbook/actions/EditWorkbookAction';
import { INamedItemInfo } from '../../models/resourceInfoParts';
import { EntityLinkProps } from './EntityLink';

export interface ContentTooltipProps {
  content: IContentInfo;
  urls: SpacesSiteUrls;
  inProjectSpace?: boolean;
  inPersonalSpace?: boolean;
  lastUpdatedTimestamp?: Date;
  draftLastUpdatedTimeStamp?: string;
}

export const TooltipDescriptionTestId = 'tooltip-description-field';

export const ContentDescriptionClassNames = [
  'tb-textile',
  'tb-textile-preview-container',
  DetailsTooltipStyles.MetadataValueContentDescription
].join(' ');

export const getProjectLink = (project: INamedItemInfo, urls: SpacesSiteUrls): EntityLinkProps => {
  return project ? {
    href: urls.projectUrl(project.id),
    iconImagePath: null,
    name: project.name
  } : null;
};

export const getPersonalSpaceLink = (urls: SpacesSiteUrls): EntityLinkProps => {
  return {
    name: Messages.personalSpaceGridLabel(),
    href: urls.personalSpaceUrl(),
    iconImagePath: null
  };
};

export function handleContinueEditingAction(content: IContentInfo): () => void {
  return () => {
      if (content.contentType === 'workbook') {
          getAppStore().dispatch(editWorkbookDraft(content, 'Thumbnail_ContinueEditing'));
      }
  };
}

export interface StatusTooltipProps {
  content: IDataSourceInfo;
  urls: SpacesSiteUrls;
  federatedCount?: number;
  isWorkbookPlace?: boolean;
}
